import { useState } from 'react';

const faqs = [
  {
    q: '暗网吃瓜的爆料信息可靠吗？',
    a: '暗网吃瓜采用多重信源交叉验证机制，每条爆料均标注信源可信度评级（A/B/C/D 四级）。A 级为多方独立信源交叉验证；B 级为单一可靠信源；C 级为匿名投稿待核实；D 级为传闻。建议用户结合评级理性判断，不盲目相信任何单一信息。',
  },
  {
    q: '如何在暗网吃瓜搜索特定人物或事件的黑料？',
    a: '在首页搜索框或专题索引页面，你可以通过输入人物姓名、事件关键词、行业标签等进行精准检索。系统支持按时间范围、热度排序、信源评级等多维度筛选。目前检索功能覆盖平台收录的全部爆料条目。',
  },
  {
    q: '如何向暗网吃瓜匿名投稿爆料？',
    a: '通过页面顶部的「爆料投稿」入口或直接发送邮件至 tips@anwangchigua.example.com 即可匿名投稿。所有投稿均经过端到端加密处理，投稿人 IP 地址与邮箱地址不会被记录或公开。重大独家爆料一经核实发布，投稿人将获得平台奖励。',
  },
  {
    q: '暗网吃瓜的内容为什么有时会被删除或修改？',
    a: '当爆料内容涉及当事人隐私权、名誉权等法律风险，或经核实后发现信息存在重大事实错误时，平台编辑团队会依法依规进行内容调整。此外，如当事人通过法律途径提交有效证明文件要求删除不实信息，平台也将配合处理。所有操作均有操作日志可追溯。',
  },
  {
    q: '暗网吃瓜有移动客户端吗？收费吗？',
    a: '暗网吃瓜提供 iOS 与 Android 双平台客户端，支持离线缓存、推送提醒与夜间模式。目前平台所有功能（包括检索、浏览、投稿）均完全免费。客户端下载入口请访问页面「客户端入口」区域。未来如推出增值服务将另行公告。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于暗网吃瓜使用与投稿的常见疑问，快速解答你的问题
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-300/30 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}